import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';


class TopMenuItem extends Component {
  render() {

    //console.log('render nav link!',this.props.router);

    return (
      <NavLink exact={this.props.route=='/'?true:false} className="dib clear tdni w1 menuHeight" to={this.props.route} activeClassName="bg-b1">
        <span className="up12 h100 splice m-hpadd10 h-hpadd20"><span className="cell s-auto s-middle">
          {this.props.name}
        </span></span>
      </NavLink>
    )
  }
}

function mapStateToProps(state) {
  return {
    router:state.router,
  }
}

export default connect(mapStateToProps)(TopMenuItem);